export const ERROR_MESSAGES = Object.freeze({
  PHONE_INVALID: "Please enter a valid phone number for the selected country.",
  ISD_REQUIRED: "Please select a country / ISD code.",
  OTP_INVALID: "Please enter a valid OTP.",
  OTP_SEND_FAILED: "Error sending OTP.",
  OTP_SENT_SUCCESS: "OTP sent successfully!",
  CAPTCHA_FAILED: "Failed to get captcha token.",
  LOGIN_SUCCESS: "Login successful!",
  COUNTRY_LOADING: "Loading countries...",
  COUNTRY_SELECT_PLACEHOLDER: "Select country",
  COUNTRY_LOAD_FAILED: "Failed to load countries",
  COUNTRY_NONE_AVAILABLE: "No countries available",
  COUNTRY_LOAD_RETRY:
    "Could not load country list. Refresh the page and try again.",
  SELF_LOOKUP_BLOCKED: "You cannot search for your own details.",
  CUSTOMER_NOT_FOUND: "No customer found with the provided phone number.",
  CUSTOMER_FETCH_FAILED: "Failed to fetch customer info.",
  UNEXPECTED_RESPONSE: "Unexpected response format.",
  CURRENCY_FORMAT_MISSING_OPTIONS: "currencyCode is required to format currency.",
  NO_PENDING_ORDERS: "No pending orders found for this customer.",
});
